import PropTypes from 'prop-types'
import React, { Component } from 'react'
import BadgeGroup from '../../misc/BadgeGroup/BadgesGroup'

class BadgesOverview extends Component {
  static propTypes = {
    badges: PropTypes.object.isRequired,
    awardBadges: PropTypes.object.isRequired,
    badgesProgress: PropTypes.object.isRequired,
    award: PropTypes.object.isRequired,
    activity: PropTypes.object.isRequired,
    isBadgesStrictModeEnabled: PropTypes.object.isRequired
  }

  render() {
    const { badges, badgesProgress, awardBadges, award, activity, isBadgesStrictModeEnabled } = this.props

    return (
      <div>
        { badges && Object.keys(badges).map(item => {
          const groupDto = badges[item]

          const badgesProgressDto = badgesProgress[item]

          return (<BadgeGroup badges={groupDto} badgesProgress={badgesProgressDto} awardBadges={awardBadges} award={award} activity={activity} isBadgesStrictModeEnabled={isBadgesStrictModeEnabled} />)
      })}
      </div>
    )
  }
}

export default BadgesOverview
